import React, { useState, useEffect } from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
// import ProjectContainer from "../containers/project";
import PageTitle from "../components/page-title";
import Layout from "../layouts";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
// import ProjectItem from "../components/project/project-item";
// import ProjectForm from "../components/project-form";
import FileUploader from "../components/fileUploader.js";
import axios from "axios";
import cogoToast from "cogo-toast";

import Select from "react-select";

const AddProjectImage = () => {
    const [files, setFiles] = useState();
    const [loading, setLoading] = useState(true);
    const [project, setProject] = useState();
    const [data, setData] = useState({
        id: 1,
        media: {
            thumb: "./images/project/project-1.jpg",
            image: "./images/project-details/project-details.jpg",
        },
        title: "Enter your title...",
        description: "",
        img: "",
    });

    useEffect(() => {
        axios
            .get("https://soul-house-harmony.onrender.com/project/all")
            .then((res) => {
                console.log(res.data);
                const temp = [];
                res.data.allProjects.map((x) => {
                    temp.push({
                        value: x._id,
                        label: x.name,
                    });
                });
                setData(temp);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                cogoToast.info("Error submitting form", {
                    position: "bottom-left",
                });
            });
    }, []);

    const handleSubmit = () => {
        console.log(files);
        let bodyFormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            bodyFormData.append("files", files[i], files[i]?.name);
        }

        bodyFormData.append("project", project);

        axios
            .post(
                "https://soul-house-harmony.onrender.com/media/add",
                bodyFormData,
                {
                    headers: {
                        Authorization: JSON.parse(
                            sessionStorage.getItem("admin")
                        ).token,
                    },
                }
            )
            .then((res) => {
                console.log(res);
                if (res.status === 200)
                    cogoToast.success("submitted successfully", {
                        position: "bottom-left",
                    });
            })
            .catch((err) => {
                console.log(err);
                cogoToast.info("Error submitting form", {
                    position: "bottom-left",
                });
            });
    };

    return (
        <React.Fragment>
            <Layout>
                <SEO title="Andle - Project" />

                <div className="main-wrapper">
                    <Header />
                    <div className="container">
                        <PageTitle title="Add Projects Details" />
                        <div
                            className="messonry-button"
                            data-aos="fade-up"
                            data-aos-duration="1200"
                        ></div>
                    </div>
                    <div className="section p-10">
                        <div
                            className="row grid project-list p-5"
                            style={{ justifyContent: "space-around" }}
                        >
                            <div
                                style={{ marginBottom: "50px", color: "black" }}
                            >
                                <Select
                                    isSearchable={true}
                                    isClearable={true}
                                    isLoading={loading}
                                    options={data}
                                    onChange={(e) => {
                                        console.log(e);
                                        setProject(e.value);
                                    }}
                                />
                            </div>

                            <FileUploader
                                onFileUpload={(files) => {
                                    setFiles(files);
                                }}
                            />
                        </div>
                        <div className="form-btn">
                            <button onClick={handleSubmit}>Submit</button>
                        </div>
                    </div>
                    <Footer />
                </div>
                <ScrollToTop />
            </Layout>
        </React.Fragment>
    );
};

export default AddProjectImage;
